import { API_URL } from './Constants';
import ApiService from './ApiService';

class TrangPageApi {

    static getAllData = async () => {
        try {
            return await ApiService.getDataWithParams(API_URL + "/trang/all-data");
        } catch (error) {
        }
    };

    static getAllType = async () => {
        try {
            return await ApiService.getDataWithParams(API_URL + "/trang/all-type");
        } catch (error) {
        }
    };

    static getListByCat = async (catId) => {
        try {
            let params = {};
            if (catId !== null) {
                params = { catId };
            }
            return await ApiService.getDataWithParams(API_URL + "/trang/list-by-cat", params);
        } catch (error) {
        }
    };

    static getDataByPostId = async (postId) => {
        try {
            let params = {};
            if (postId !== null) {
                params = { postId };
            }
            return await ApiService.getDataWithParams(API_URL + "/trang/chi-tiet", params);
        } catch (error) {
        }
    };
    
     // --------------- ADMIN -----------------
     static submitPost = async (formData) => {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("seoUrl", formData.seoUrl);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);

        if (formData.image) {
            data.append("image", formData.image);
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }
        if (formData.file) {
            data.append("file", formData.file);
        }
        try {
            const response = await ApiService.postFormData(API_URL + "/trang/create", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static updatePost = async (formData) => {
        const data = new FormData();
        data.append("postId", formData.postId);
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("seoUrl", formData.seoUrl);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isDeleteFile", formData.isDeleteFile);
        data.append("isDeleteImage", formData.isDeleteImage);

        if (formData.image) {
            data.append("image", formData.image);
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }
        if (formData.file) {
            data.append("file", formData.file);
        }
        try {
            const response = await ApiService.postFormData(API_URL + "/trang/update", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static getChiTietTrangAdmin = async (postId, postType) => {
        try {
            let params = { postId, postType };

            console.log(params)

            return await ApiService.getDataWithParams(API_URL + "/trang/admin/detail", params);
        } catch (error) {
        }
    }
}

export default TrangPageApi;
